import React from "react";
import {css} from "@emotion/react";

import {Highlight, Text, TextVariantUnionType} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../helpers/OfferType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    rooms: number;
    offerType: number;
    offerName: string;
    textVariant?: TextVariantUnionType;
    highlightBoldText?: boolean;
    className?: string;
}

export const QWPropertyInfoHeading = (props: IProps) => {
    const {rooms, offerType, offerName, textVariant = "body_copy_1", highlightBoldText, className} = props;
    const flatPlural = pluralize(["pokój", "pokojowe", "pokoi"]);
    const houseFlatPlural = pluralize(["pokój", "pokoje", "pokoi"]);

    const setFlatPluralText = () => {
        switch (offerType) {
            case OfferType.FLAT:
                return `${rooms} ${flatPlural(rooms)}`;
            case OfferType.HOUSE:
                return `${rooms} ${houseFlatPlural(rooms)}`;
            case OfferType.COMMERCIAL:
            default:
                return "";
        }
    };

    const TextContainer = highlightBoldText ? Highlight : React.Fragment;

    return (
        <Text css={textPadding} as="div" variant={textVariant} className={className}>
            {getOfferTypeNameCapital(offerType)}{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{setFlatPluralText()}</TextContainer>
            </Text>{" "}
            w inwestycji{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{offerName}</TextContainer>
            </Text>
        </Text>
    );
};

const textPadding = css`
    padding: 2.4rem 1.6rem 1.2rem 1.6rem;
`;
import React from "react";
import {css} from "@emotion/react";

import {Highlight, Text, TextVariantUnionType} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

import {getOfferTypeNameCapital} from "../../helpers/OfferType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    rooms: number;
    offerType: number;
    offerName: string;
    textVariant?: TextVariantUnionType;
    highlightBoldText?: boolean;
    className?: string;
}

export const QWPropertyInfoHeading = (props: IProps) => {
    const {rooms, offerType, offerName, textVariant = "body_copy_1", highlightBoldText, className} = props;
    const flatPlural = pluralize(["pokój", "pokojowe", "pokoi"]);
    const houseFlatPlural = pluralize(["pokój", "pokoje", "pokoi"]);

    const setFlatPluralText = () => {
        switch (offerType) {
            case OfferType.FLAT:
                return `${rooms} ${flatPlural(rooms)}`;
            case OfferType.HOUSE:
                return `${rooms} ${houseFlatPlural(rooms)}`;
            case OfferType.COMMERCIAL:
            default:
                return "";
        }
    };

    const TextContainer = highlightBoldText ? Highlight : React.Fragment;

    return (
        <Text css={textPadding} as="div" variant={textVariant} className={className}>
            {getOfferTypeNameCapital(offerType)}{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{setFlatPluralText()}</TextContainer>
            </Text>{" "}
            w inwestycji{" "}
            <Text as="b" variant={textVariant} strong>
                <TextContainer>{offerName}</TextContainer>
            </Text>
        </Text>
    );
};

const textPadding = css`
    padding: 2.4rem 1.6rem 1.2rem 1.6rem;
`;
